import UserImpl from '@qality/common-components/src/select/UserTestImpl';
import MapperService from '@qality/common-service/src/MapperService';
import StorageOfUniqueServices from '@qality/common-service/src/StorageOfUniqueServices';

import { ExecutionStatus } from './ExecutionStatus';
import { Issue } from './Issue';
import { TestCaseInCycle } from './TestCaseInCycle';
import TestCycle from './TestCycle';

export default class HistoryStep {
  createdDate: string;
  status: ExecutionStatus;
  comment: string;
  id: number;
  testCycle: TestCycle;
  executionAssignee: UserImpl;
  linkedIssues: Array<Issue>;
  linkedIssuesErrors: number;

  constructor(
    createdDate: string,
    status: ExecutionStatus,
    comment: string,
    id: number,
    testCaseInCycle?: TestCaseInCycle,
    executionAssignee?: UserImpl,
    linkedIssues?: {
      foundIssues: Array<Issue>;
      notFoundCount: number;
    }
  ) {
    const getBrowseIssueUrl =
      StorageOfUniqueServices.get('URLService').getIssueURL;

    this.createdDate = createdDate;
    this.status = status;
    this.comment = comment;
    this.id = id;
    this.testCycle = testCaseInCycle ? testCaseInCycle.testCycle : null;
    this.executionAssignee = executionAssignee;
    if (linkedIssues) {
      // done issues should be at the bottom
      this.linkedIssues = linkedIssues.foundIssues
        .map((issue) =>
          MapperService.formatJIRAIssueToIssue(issue, getBrowseIssueUrl)
        )
        .sort((issue1, issue2) => {
          if (
            issue1.status?.kind === 'success' &&
            issue2.status?.kind === 'success'
          ) {
            return 0;
          }

          if (issue1.status?.kind === 'success') {
            return 1;
          }

          if (issue2.status?.kind === 'success') {
            return -1;
          }

          return 0;
        });
      this.linkedIssuesErrors = linkedIssues.notFoundCount;
    }
  }
}
